// @flow

import React from 'react';
import { colors } from 'seedling/constants';
import styled from 'styled-components';

type IconProps = {
  verticalAlign: string,
  color: string,
  hoverColor: string,
  size: string,
  marginLeft: string,
};

const LightningIcon = (props: IconProps) => {
  const { size, color, verticalAlign, hoverColor, marginLeft, ...rest } = props;

  return (
    <StyledSvg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      {...rest}
    >
      <path
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.38263 10.4068C8.71884 10.4068 8.95924 10.732 8.86065 11.0534L7.66191 14.9619L14.3421 8.25024H11.4535C11.063 8.25024 10.8232 7.82265 11.0269 7.48947L13.1598 4H8.9654L5.38972 10.4068H8.38263ZM8.37831 2.5C8.19707 2.5 8.03003 2.59807 7.9417 2.75633L3.66486 10.4195C3.29284 11.086 3.77472 11.9068 4.53807 11.9068H7.02994L5.63573 16.4526C5.32976 17.4501 6.56443 18.1908 7.30053 17.4512L16.7633 7.94405C17.2027 7.50261 16.89 6.75024 16.2671 6.75024H13.2368L15.3697 3.26077C15.5734 2.9276 15.3336 2.5 14.9431 2.5H8.37831Z"
      />
    </StyledSvg>
  );
};

const StyledSvg = styled.svg`
  vertical-align: ${props => props.verticalAlign};
  margin-left: ${props => props.marginLeft};

  &:hover {
    path {
      fill: ${props => props.hoverColor || props.color};
    }
  }
`;

LightningIcon.displayName = 'LightningIcon';

LightningIcon.defaultProps = {
  verticalAlign: 'middle',
  color: colors.mediumGrey,
  size: '20px',
  marginLeft: '0px',
};

export default LightningIcon;
